import * as React from 'react';

import { EmptyState } from '../../../components/synced/ui/EmptyState/EmptyState';

export const BlockedPage: React.FC = () => {
    return <EmptyState icon="fa-ban" title="Учётная запись заблокирована" text="Обратитесь к вашему администратору." />;
};
